import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FavoriteBorder } from "@mui/icons-material";

export default function Productdetail() {
  // const navigate = useNavigate();
  // const [open, setOpen] = React.useState(false);
  const [data, setData] = useState([]);
  useEffect(() => {
    const url = "https://cloudapp.aaragroups.com/api/product-deatils/";

    axios
      .post(
        url,
        {},
        {
          headers: { Token: "0b43126697377ebb2cc943670d71469bd5cc0f62" },
        }
      )
      .then((res) => setData(res?.data?.data))
      .catch((err) => console.log("err"));
  }, []);
  console.log(data);

  return (
    <>
      <div className="flex flex-col justify-center gap-10">
        <div className="flex justify-center p-8 hm">
          {data?.map((item) => {
            return (
              <>
                <div className="flex">
                  <img src={item.product_image} alt="" />
                </div>
                <div className="flex flex-col justify-start gap-5 border p-4 text-white  ">
                  <p className="font-bold text-2xl">{item.title}</p>
                  <p className="">{item.sub_category}</p>
                  <p className="">
                    {item.stock_sataus} (Product HSN : {item.HSN})
                  </p>
                  <p className="font-bold ">WEIGHT</p>
                  <p className="border p-2 w-16 border-black">
                    {item.variant_storage_value}
                  </p>
                  <p>PACK OF</p>
                  <p>MRP ₹210.0 ₹210.0 Save0%</p>
                  <p>Inclusive of all taxes</p>
                  <div className="border border-gray-400 bg-gray-400 p-4">
                    <p>
                      • FREE Delivery on orders by Amaka Industries over ₹499
                    </p>
                  </div>
                </div>
              </>
            );
          })}
        </div>

        <div className="py-4 px-8">
          <p className="text-red-500 font-bold text-2xl">Product Description</p>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography className="!font-bold !text-xl">
                Description
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography className="!font-bold !text-xl">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography className="!font-bold !text-xl">
                Dant Kanti Toothpaste
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>
                Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Suspendisse malesuada lacus ex, sit amet blandit leo lobortis
                eget.
              </Typography>
            </AccordionDetails>
          </Accordion>
        </div>
        <div className="py-3 px-10">
          <p className="font-bold text-xl"> Related Products</p>
        </div>
        <div className="lg:px-10 py-5 gap-10 lg:flex justify-center">
          <div className="max-w-xs p-6 rounded-md shadow-md bg-gray-50 text-gray-900">
            <img
              src="https://source.unsplash.com/random/300x300/?1"
              alt=""
              className="object-cover object-center w-full rounded-md h-72 bg-gray-500"
            />
            <div className="mt-6 mb-2">
              <span className="block  font-medium tracking-widest uppercase text-sky-600">
                title
              </span>
              <h2 className="text-xl font-semibold tracking-wide">
                Description
              </h2>
            </div>
            <p className="text-gray-800 text-xl">Price</p>
            <div className="flex justify-between">
              <Button variant="outlined">Add To Cart</Button>
              <FavoriteBorder />
            </div>
          </div>
          <div className="max-w-xs p-6 rounded-md shadow-md bg-gray-50 text-gray-900">
            <img
              src="https://source.unsplash.com/random/300x300/?1"
              alt=""
              className="object-cover object-center w-full rounded-md h-72 bg-gray-500"
            />
            <div className="mt-6 mb-2">
              <span className="block  font-medium tracking-widest uppercase text-sky-600">
                title
              </span>
              <h2 className="text-xl font-semibold tracking-wide">
                Description
              </h2>
            </div>
            <p className="text-gray-800 text-xl">Price</p>
            <div className="flex justify-between">
              <Button variant="outlined">Add To Cart</Button>
              <FavoriteBorder />
            </div>
          </div>
          <div className="max-w-xs p-6 rounded-md shadow-md bg-gray-50 text-gray-900">
            <img
              src="https://source.unsplash.com/random/300x300/?1"
              alt=""
              className="object-cover object-center w-full rounded-md h-72 bg-gray-500"
            />
            <div className="mt-6 mb-2">
              <span className="block  font-medium tracking-widest uppercase text-sky-600">
                title
              </span>
              <h2 className="text-xl font-semibold tracking-wide">
                Description
              </h2>
            </div>
            <p className="text-gray-800 text-xl">Price</p>
            <div className="flex justify-between">
              <Button variant="outlined">Add To Cart</Button>
              <FavoriteBorder />
            </div>
          </div>
          <div className="max-w-xs p-6 rounded-md shadow-md bg-gray-50 text-gray-900">
            <img
              src="https://source.unsplash.com/random/300x300/?1"
              alt=""
              className="object-cover object-center w-full rounded-md h-72 bg-gray-500"
            />
            <div className="mt-6 mb-2">
              <span className="block  font-medium tracking-widest uppercase text-sky-600">
                title
              </span>
              <h2 className="text-xl font-semibold tracking-wide">
                Description
              </h2>
            </div>
            <p className="text-gray-800 text-xl">Price</p>
            <div className="flex justify-between">
              <Button variant="outlined">Add To Cart</Button>
              <FavoriteBorder />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
